jQuery(document).ready(function () {
    const loaderHTML = `
        <div id="loader-container" style="display:none;">
            <div class="loaderBox" id="loader1"></div>
            <div class="loaderBox" id="loader2"></div>
            <div class="loaderBox" id="loader3"></div>
            <div class="loaderBox" id="loader4"></div>
            <div class="loaderBox" id="loader5"></div>
        </div>
        <style>
            #loader-container {
                width: 100%;
                height: 100vh;
                position: fixed;
                top: 0;
                left: 0;
                z-index: 9999;
                background-color: rgba(255, 255, 255, 0.7);
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                opacity: 1 !important;
            }
            .loaderBox {
                width: 20px;
                height: 60px;
                background-color: #005a87;
                border-radius: 50px;
                animation: loader 1s linear infinite;
            }
            #loader1 {
                animation-delay: .1s;
            }
            #loader2 {
                animation-delay: .2s;
            }
            #loader3 {
                animation-delay: .3s;
            }
            #loader4 {
                animation-delay: .4s;
            }
            #loader5 {
                animation-delay: .5s;
            }
            @keyframes loader {
                0%, 100% {
                    height: 90px;
                }
                50% {
                    height: 20px;
                }
            }
        </style>
    `;
    jQuery('body').append(loaderHTML);

    function showLoader() {
        jQuery('#loader-container').fadeIn();
    }

    function hideLoader() {
        jQuery('#loader-container').fadeOut();
    }

    jQuery(document).ajaxStart(function () {
        showLoader(); // Show loader when any AJAX starts
    }).ajaxStop(function () {
        hideLoader(); // Hide loader when all AJAX calls complete
    });

    jQuery('#country-select, #zone-select, #state-select, #city-select').on('change', function () {
        const id = jQuery(this).attr('id');

        if (id === "zone-select") {
            jQuery('#state-select').empty().append('<option>Select State</option>');
            jQuery('#city-select').empty().append('<option>Select City</option>');
            const zone = jQuery(this).val();
            if (zone) {
                fetchStatesByZone(zone);
            }
        }

        if (id === "state-select") {
            jQuery('#city-select').empty().append('<option>Select City</option>');
            const state = jQuery(this).val();
            if (state) {
                fetchCitiesByState(state);
            }
        }

        if (id === "country-select") {
            jQuery('#zone-select').val('');
            jQuery('#state-select').empty().append('<option>Select State</option>');
            jQuery('#city-select').empty().append('<option>Select City</option>');
            if (jQuery(this).val() !== "india") {
                jQuery('#zone-select, #state-select, #city-select').attr("disabled", true);
            } else {
                jQuery('#zone-select, #state-select, #city-select').removeAttr("disabled");
            }
        }

        // Always refetch distributors when a filter changes
        fetchDistributors(1);
    });

    function fetchStatesByZone(zone) {
        const country = jQuery('#country-select').val();
        jQuery.ajax({
            type: 'POST',
            url: ajax_obj.ajax_url,
            data: {
                action: 'load_states_cities_by_zone',
                zone: zone,
                country: country
            },
            success: function (response) {
                if (response.success) {
                    const states = response.data.states;
                    const stateSelect = jQuery('#state-select');
                    stateSelect.empty().append('<option>Select State</option>');
                    states.forEach(state => {
                        stateSelect.append(`<option value="${state}">${state}</option>`);
                    });

                    jQuery('#city-select').empty().append('<option>Select City</option>');
                }
            }
        });
    }

    function fetchCitiesByState(state) {
        const country = jQuery('#country-select').val();
        const zone = jQuery('#zone-select').val();

        jQuery.ajax({
            type: 'POST',
            url: ajax_obj.ajax_url,
            data: {
                action: 'load_cities_by_state',
                state: state,
                country: country,
                zone: zone
            },
            success: function (response) {
                if (response.success) {
                    const cities = response.data.cities;
                    const citySelect = jQuery('#city-select');
                    citySelect.empty().append('<option>Select City</option>');
                    cities.forEach(city => {
                        citySelect.append(`<option value="${city}">${city}</option>`);
                    });
                }
            }
        });
    }

    function fetchDistributors(page) {
        const selectedCountry = jQuery('#country-select').val();
        const selectedZone = jQuery('#zone-select').val();
        const selectedState = jQuery('#state-select').val();
        const selectedCity = jQuery('#city-select').val();

        const data = {
            action: 'filter_distributors_by_country',
            country: selectedCountry,
            page: page
        };

        if (selectedCountry === 'india' && selectedZone && selectedZone !== 'Select Zone') {
            data.zone = selectedZone;
        }

        if (selectedState && selectedState !== 'Select State') {
            data.state = selectedState;
        }

        if (selectedCity && selectedCity !== 'Select City') {
            data.city = selectedCity;
        }

        jQuery.ajax({
            type: 'POST',
            url: ajax_obj.ajax_url,
            data: data,
            success: function (response) {
                jQuery("#all-results").hide();
                jQuery('#filtered-results').html(response);
            },
            error: function (xhr, status, error) {
                console.error('Error: ' + xhr.status);
            }
        });
    }

    // Handle pagination
    jQuery(document).on('click', '.ajax-pagination-link', function (e) {
        e.preventDefault();
        const page = jQuery(this).data('page');
        if (page) {
            fetchDistributors(page);
        }
    });
});
